/* @flow */

export default class SetPersonLegalInfoRequest {
  companyId: number;
  isAdministrator: boolean;
}
